<template>
  <v-row
    no-gutters
    class="specialcar-tablelike"
  >
    <v-col
      v-for="(item, index) in items"
      :key="index"
      cols="4"
      class="item"
    >
      <div class="item-name">{{item.name}}</div>
      <div class="item-value">{{item.value}}</div>
    </v-col>
  </v-row>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.specialcar-tablelike {
  border: {
    top: solid 1px $divider-color;
    left: solid 1px $divider-color;
  }

  .item {
    border: {
      bottom: solid 1px $divider-color;
      right: solid 1px $divider-color;
    }
  }

  .item-name {
    @extend %typo-caption;
    padding: .25rem;
    background-color: $table-th-color;
    color: $title-white-text-color;
    text-align: center;
  }

  .item-value {
    padding: .5rem .25rem;
    background-color: white;
    text-align: center;
  }
}
</style>

<script>
export default {
  name: 'CarTablelike',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
